import { UsersRound } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { toast } from "sonner";

import { PageHeader } from "../components/PageHeader";
import { TeamAdjustmentsModal } from "../components/TeamAdjustmentsModal";
import { TeamDrawActions } from "../components/TeamDrawActions";
import { TeamPitchList } from "../components/TeamPitchList";
import { TeamWaitingList } from "../components/TeamWaitingList";
import { useAuth } from "../context/AuthContext";
import api, { apiError } from "../lib/api";
import "./TeamsPageV3.css";
import "./TeamsPageV4.css";
import "./TeamsPageAdjustments.css";

export default function TeamsPageV4() {
  const { user } = useAuth();
  const [selectedPlayerId, setSelectedPlayerId] = useState(null);
  const matchQuery = useQuery({ queryKey: ["current-match"], queryFn: () => api.get("/matches/current").then((result) => result.data.match) });
  const usersQuery = useQuery({ queryKey: ["players"], queryFn: () => api.get("/users").then((result) => result.data) });
  const match = matchQuery.data;
  const users = usersQuery.data || [];
  const lookup = Object.fromEntries(users.map((item) => [item.id, item]));
  const waiting = users.filter((player) => match?.waiting?.includes(player.id));
  const admin = user?.role === "admin";
  const canAdjust = admin && match?.teams?.length && !match.published;
  const action = async (path, method = "post", body) => {
    try {
      const { data } = await api[method](path, body);
      toast.success(data.message || "Atualização salva.");
      await matchQuery.refetch();
      return true;
    } catch (error) {
      toast.error(apiError(error));
      return false;
    }
  };
  const movePlayer = async (playerId, targetTeamIndex) => {
    const saved = await action("/matches/current/move", "put", {
      player_id: playerId,
      target_team_index: targetTeamIndex,
    });
    if (saved) {
      setSelectedPlayerId(null);
    }
  };
  const swapPlayer = async (firstPlayerId, secondPlayerId) => {
    const saved = await action("/matches/current/swap", "put", {
      first_player_id: firstPlayerId,
      second_player_id: secondPlayerId,
    });
    if (saved) {
      setSelectedPlayerId(null);
    }
  };
  if (!match) return <><PageHeader title="Times" /><section className="page-content"><div className="empty-state"><UsersRound size={38} /><h2>Nenhuma pelada agendada</h2></div></section></>;
  return (
    <>
      <PageHeader title="Times" subtitle="4 times de 7 jogadores" />
      <section className="page-content teams-arena" data-testid="teams-page">
        {!match.teams?.length ? (
          <div className="empty-state draw-state" data-testid="teams-before-draw">
            <UsersRound size={40} />
            <h2>Pronto para o sorteio</h2>
            <p data-testid="confirmed-player-count">{match.confirmed.length} confirmados de {match.vagas} vagas mensais.</p>
            {admin && <button className="button button-primary" onClick={() => action("/matches/current/draw")} data-testid="draw-teams-button">Sortear 4 times</button>}
          </div>
        ) : (
          <>
            <TeamDrawActions admin={admin} onAction={action} published={match.published} />
            {canAdjust && <p className="team-adjustment-note" data-testid="team-adjustment-note">Toque no ícone de um jogador para mover ou trocar antes de publicar.</p>}
            <TeamPitchList editable={canAdjust} lookup={lookup} onSelectPlayer={setSelectedPlayerId} teams={match.teams} />
          </>
        )}
        <TeamWaitingList admin={admin} onAction={action} waiting={waiting} />
      </section>
      {selectedPlayerId && canAdjust && <TeamAdjustmentsModal match={match} selectedPlayerId={selectedPlayerId} onClose={() => setSelectedPlayerId(null)} onMove={movePlayer} onSwap={swapPlayer} />}
    </>
  );
}